import axios, { AxiosError } from "axios";

import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { executeCaptcha } from "./executeCaptcha";
import { SEND_REPORT_ABOUT_PROPERTY } from "@/constants";
import { SendReportRequestData } from "@/types";

export const useReportProperty = (onSuccess: () => void) =>
  useMutation<unknown, AxiosError, SendReportRequestData>({
    onSuccess: onSuccess,
    onError: (error) => {
      toast.error(error.message);
      console.error(error);
    },
    mutationFn: async ({ requestBody }) => {
      const captchaToken = await executeCaptcha();

      const res = await axios.post(SEND_REPORT_ABOUT_PROPERTY, {
        ...requestBody,
        captchaToken,
      });

      return res.data;
    },
  });
